var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(-8607 -1224)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(8607 1224)",
    fill: "#286bcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M11.4,5.427,6.624,10.033,5.358,8.68a.692.692,0,0,0-.867-.047.611.611,0,0,0-.173.807l1.5,2.44a.82.82,0,0,0,1.367,0C7.424,11.567,12,6.107,12,6.107c.6-.613-.127-1.153-.607-.687Z",
    transform: "translate(8607 1223.5)",
    fill: "#eef5ff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActive);
export default __webpack_public_path__ + "static/media/icon-active.8998bafb924724e7ac13b0a97b292aba.svg";
export { ForwardRef as ReactComponent };